import { IconArrowInbox } from 'central-icons/IconArrowInbox';

import { FeatureFlag } from '@revelio/core';
import { IconButton, Menu, MenuButton, MenuList } from '@revelio/ui';

import { useUnleashFlag } from '../../../../shared/unleash-flags/use-unleash-flag';
import { isScreenerV2Page } from '../../utils/routing-helpers';
import { usePageExport } from '../Chart/chart-menu/PageExportProvider';
import {
  usePageConfig,
  useTabContentConfig,
} from '../PageConfigProvider/PageConfigProvider';
import { PageType, RevelioPageId } from '../PageConfigProvider/types';
import { ShareReportMenuItem } from '../SharedReport/ShareReportModal';
import { DataExportMenuItem } from './DataExportMenuItem';
import { PdfExportMenuItem } from './PdfExportMenuItem';
import { PostingDiscoveryDataExportMenuItem } from './PostingDiscoveryDataExportMenuItem';
import { PostingDiscoverySelectedDataExportMenuItem } from './PostingDiscoverySelectedDataExportMenuItem';
import { PptExportMenuItem } from './PptExportMenuItem';
import { PrintToPdfMenuItem } from './PrintToPdfMenuItem';
import { ScreenerDataExportMenuItem } from './ScreenerDataExportMenuItem';
import { TalentDiscoveryDataExportMenuItem } from './TalentDiscoveryDataExportMenuItem';
import { TalentDiscoverySelectedDataExportMenuItem } from './TalentDiscoverySelectedDataExportMenuItem';

const EXPERIMENTAL_PRINT_TO_PDF_ENABLED = false;

export const DownloadMenuButton = () => {
  const { revelioPageId } = useTabContentConfig();
  const isTalentDiscoveryPage =
    revelioPageId === RevelioPageId.TALENT_DISCOVERY;
  const isPostingsDiscoveryPage =
    revelioPageId === RevelioPageId.POSTING_DISCOVERY;
  const isScreenerPage = isScreenerV2Page(revelioPageId);

  const { config: pageConfig } = usePageConfig();
  const { isPageDataReady } = usePageExport();
  const isSharedReportsEnabled = useUnleashFlag(FeatureFlag.SharedReports);
  const isNewDashboardLayout = useUnleashFlag(FeatureFlag.DashboardNewLayout);

  const isReportPage = pageConfig.type === PageType.REPORT;
  const isButtonDisabled = isReportPage && !isPageDataReady;
  const showShareMenuItem = isReportPage && isSharedReportsEnabled;

  return (
    <Menu>
      <MenuButton>
        <IconButton
          variant={isNewDashboardLayout ? 'ghost' : 'outlined'}
          icon={<IconArrowInbox size={16} />}
          aria-label="More actions"
          title={isButtonDisabled ? 'Preparing download...' : 'Download'}
          data-testid="download-menu-button"
          disabled={isButtonDisabled}
        />
      </MenuButton>
      <MenuList align="end">
        {isTalentDiscoveryPage && <TalentDiscoveryDataExportMenuItem />}
        {isTalentDiscoveryPage && <TalentDiscoverySelectedDataExportMenuItem />}
        {isPostingsDiscoveryPage && <PostingDiscoveryDataExportMenuItem />}
        {isPostingsDiscoveryPage && (
          <PostingDiscoverySelectedDataExportMenuItem />
        )}
        {isScreenerPage && <ScreenerDataExportMenuItem />}
        {!isPostingsDiscoveryPage && <PdfExportMenuItem />}
        {EXPERIMENTAL_PRINT_TO_PDF_ENABLED && <PrintToPdfMenuItem />}
        {!isPostingsDiscoveryPage && <DataExportMenuItem />}
        {!isPostingsDiscoveryPage && <PptExportMenuItem />}
        {showShareMenuItem && <ShareReportMenuItem />}
      </MenuList>
    </Menu>
  );
};
